import { useTranslation } from "react-i18next";

import type { HaNFloorGroup } from "@lib/logic";

import { FloorSuggestionTile } from "../../shared/FloorSuggestionTile";
import { HaNResultList } from "../../shared/HaNResultList/HaNResultList";
import type { FacilityCategoryEntry } from "../types";
import { FacilityCategoryEntryRows } from "./FacilityCategoryEntryRows";

type FacilityCategoryOnOtherFloorsProps = {
  floors: HaNFloorGroup<FacilityCategoryEntry>[];
};

export const FacilityCategoryOnOtherFloors = ({ floors }: FacilityCategoryOnOtherFloorsProps) => {
  const { t } = useTranslation();

  if (floors.length === 0) return null;

  return (
    <>
      <HaNResultList.Header title={t("hereAndNow:OnOtherFloors")} />

      <div className="flex flex-col gap-2 px-3 py-2">
        {floors.map(({ floorId, direction, items }) => {
          return (
            <FloorSuggestionTile
              key={floorId}
              floorId={floorId}
              direction={direction}
              description={t("hereAndNow:ResultCount", { count: items.length })}
              initiallyExpanded={false}>
              <FacilityCategoryEntryRows entries={items} />
            </FloorSuggestionTile>
          );
        })}
      </div>
    </>
  );
};
